import { connect } from 'react-redux';
import { closeModal } from './redux/modalActions';
import useScreenWidth from '../common/helpers/useScreenWidth';
import Modal from '../../ui/Modal';
import Button from '../../ui/Button';

const actions = {
  closeModal,
};

function ModalError({ modalName, closeModal }) {
  const screenWidth = useScreenWidth();

  return (
    <Modal
      variant='danger'
      label='Error'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        There is an error. Modal "{modalName}" is not found.
        (Please contact administrator.)
      </p>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalError);
